

export interface IWorkHistoryDay {
    Hours: number;
    Minutes: number;
    EmployeeProfileImageS3Url: string;
    Entries: WorkHistoryDayEntry[];
    Name: string;
}

export interface WorkHistoryDayEntry {
    Hours: number;
    Minutes: number;
    PunchInLatitude: number | null;
    PunchInLongitude: number | null;
    PunchOutLatitude: null;
    PunchOutLongitude: null;
    HierarchyItemLabel: null | string;
    PunchInTime: Date;
    PunchOutTime: Date;
    HierarchyItemId: string;
    EventTime: Date;
    IsGeoFence: boolean;
    JobId: string;
    JobName: string;
    EventAction: EventAction;
    EventType: EventType
}

export enum EventAction {
    None = 0,
    Punch = 1,
    Clicked = 2,
    Dismissed = 3
}

export enum EventType {
    None = 0,
    Enter = 1,
    Exit = 2
}